(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ussea-my-profile"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Add address toggle
  var addBtn    = document.getElementById('usseaMpAddrAddBtn');
  var addForm   = document.getElementById('usseaMpNewAddrForm');
  var addCancel = document.getElementById('usseaMpAddrAddCancel');
  if (addBtn && addForm) {
    addBtn.addEventListener('click', function () {
      var open = addForm.hasAttribute('hidden');
      addForm.toggleAttribute('hidden', !open);
      addBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      addBtn.textContent = open ? '− Cancel' : '+ Add Address';
    });
    if (addCancel) {
      addCancel.addEventListener('click', function () {
        addForm.setAttribute('hidden', '');
        addBtn.setAttribute('aria-expanded', 'false');
        addBtn.textContent = '+ Add Address';
      });
    }
  }

  // Edit / cancel per address
  document.querySelectorAll('.ussea-mp-addr-edit').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id      = btn.dataset.addr;
      var text    = document.getElementById('usseaMpAddrText' + id);
      var form    = document.getElementById('usseaMpAddrEdit' + id);
      var actions = document.getElementById('usseaMpAddrActions' + id);
      if (text)    text.setAttribute('hidden', '');
      if (actions) actions.setAttribute('hidden', '');
      if (form)    form.removeAttribute('hidden');
    });
  });

  document.querySelectorAll('.ussea-mp-addr-cancel').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id      = btn.dataset.addr;
      var text    = document.getElementById('usseaMpAddrText' + id);
      var form    = document.getElementById('usseaMpAddrEdit' + id);
      var actions = document.getElementById('usseaMpAddrActions' + id);
      if (form)    form.setAttribute('hidden', '');
      if (text)    text.removeAttribute('hidden');
      if (actions) actions.removeAttribute('hidden');
    });
  });
  // Order history accordion
  document.querySelectorAll('.ussea-mp-oh-row').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (panel) panel.toggleAttribute('hidden', expanded);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
